
import axios from "axios";

export async function Login(user) {
    try {
        const loginResponse = await axios.post("/api/auth/signin", user, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = loginResponse.data.data;

        localStorage.setItem("token", data.accessToken);

        const userResponse = await axios.get("/api/auth/user_detail", {
            headers: {
                Authorization: `Bearer ${data.accessToken}`,
            },
        });
        const userData = userResponse.data;

        localStorage.setItem("user", JSON.stringify(userData));
        return userResponse;
    } catch (error) {
        console.error("Login or user detail error:", error);
        return error.response;
    }
}

export function isJwtExpired(jwt) {
    const tokenParts = jwt.split(".");

    if (tokenParts.length !== 3) {
        return true;
    }

    const payload = JSON.parse(atob(tokenParts[1]));

    if (!payload.exp) {
        return true;
    }

    const jwtExpired = new Date(payload.exp * 1000);

    return jwtExpired < new Date();
}